import { createClient } from '@sanity/client';

export const sanityClient = createClient({
  projectId: '50m11050',
  dataset: 'production',
  apiVersion: '2023-09-19',
  useCdn: false,
});
